export interface Article {
  id: string;
  title: string;
  slug: string;
  description: string;
  category: string;
  date: string;
  readTime: string;
  authorId: string;
  imageUrl: string;
  thumbnailUrl: string;
  isFeatured: boolean;
  keywords: string[];
  summary?: string;
  image?: string;
}

export interface BaseArticle {
  id: string;
  title: string;
  slug: string;
  description: string;
  category: string;
  date: string;
  readTime: string;
  authorId: string;
  imageUrl: string;
  isFeatured: boolean;
  keywords: string[];
  summary?: string;
  image?: string;
}

export const allArticles: Article[] = [
  {
    id: "lainan-ottamisen-opas-2025",
    title: "Lainan ottamisen opas 2025",
    slug: "lainan-ottamisen-opas-2025",
    description: "Kattava opas lainan ottamiseen vuonna 2024: suunnittelu, vertailu ja valinta. Vältä yleisimmät virheet ja löydä edullisin laina.",
    category: "Lainaoppaat",
    date: "2024-01-20",
    readTime: "12 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/money-loans-01.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/money-loans-01.jpg",
    isFeatured: true,
    keywords: ["laina", "lainan ottaminen", "rahoitus", "budjetointi", "velka", "talous"],
    summary: "Kattava opas lainan ottamiseen vuonna 2024",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/money-loans-01.jpg"
  },
  {
    id: "yrittajan-rahoitusopas-2025-nain-haet-ja-saat-yrityslainaa",
    title: "Yrittäjän rahoitusopas 2025: Näin haet ja saat yrityslainaa",
    slug: "yrittajan-rahoitusopas-2025-nain-haet-ja-saat-yrityslainaa",
    description: "Opas yrittäjille: yrityslainan hakeminen, parhaat rahoitusvaihtoehdot ja vinkit onnistuneeseen lainanhakuun vuonna 2024.",
    category: "Yrityslainat",
    date: "2024-02-15",
    readTime: "15 min",
    authorId: "business-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/business-finance-02.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/business-finance-02.jpg",
    isFeatured: false,
    keywords: ["yrityslaina", "rahoitus", "yrittäjyys", "investointi", "kasvu", "liiketoiminta"],
    summary: "Opas yrittäjille: yrityslainan hakeminen, parhaat rahoitusvaihtoehdot ja vinkit onnistuneeseen lainanhakuun vuonna 2024.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/business-finance-02.jpg"
  },
  {
    id: "miten-valita-oikea-laina-eri-tilanteisiin-2025",
    title: "Miten valita oikea laina eri tilanteisiin 2025",
    slug: "miten-valita-oikea-laina-eri-tilanteisiin-2025",
    description: "Selvitä, mikä laina sopii parhaiten eri elämäntilanteisiin. Vertaile eri lainatyyppejä ja löydä itsellesi sopivin vaihtoehto.",
    category: "Lainaoppaat",
    date: "2024-03-10",
    readTime: "10 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/personal-finance-03.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/personal-finance-03.jpg",
    isFeatured: false,
    keywords: ["laina", "rahoitus", "lainatyypit", "vertailu", "talous", "budjetti"],
    summary: "Selvitä, mikä laina sopii parhaiten eri elämäntilanteisiin. Vertaile eri lainatyyppejä ja löydä itsellesi sopivin vaihtoehto.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/personal-finance-03.jpg"
  },
  {
    id: "korkojen-nousu-ja-inflaatio",
    title: "Korkojen nousu ja inflaatio",
    slug: "korkojen-nousu-ja-inflaatio",
    description: "Miten korkojen nousu ja inflaatio vaikuttavat lainoihin ja talouteen? Asiantuntijan vinkit suojautumiseen ja säästämiseen.",
    category: "Korot",
    date: "2024-04-05",
    readTime: "14 min",
    authorId: "economy-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/economy-finance-04.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/economy-finance-04.jpg",
    isFeatured: false,
    keywords: ["korot", "inflaatio", "laina", "talous", "säästäminen", "sijoittaminen"],
    summary: "Miten korkojen nousu ja inflaatio vaikuttavat lainoihin ja talouteen? Asiantuntijan vinkit suojautumiseen ja säästämiseen.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/economy-finance-04.jpg"
  },
  {
    id: "miten-inflaation-hidastuminen-vaikutti-lainojen-korkoihin-2024",
    title: "Miten inflaation hidastuminen vaikutti lainojen korkoihin 2024",
    slug: "miten-inflaation-hidastuminen-vaikutti-lainojen-korkoihin-2024",
    description: "Analyysi: kuinka inflaation hidastuminen on vaikuttanut lainojen korkoihin vuonna 2024 ja mitä se tarkoittaa lainanottajille.",
    category: "Korot",
    date: "2024-05-01",
    readTime: "11 min",
    authorId: "economy-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/interest-rates-05.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/interest-rates-05.jpg",
    isFeatured: false,
    keywords: ["inflaatio", "korot", "laina", "talous", "markkinat", "analyysi"],
    summary: "Analyysi: kuinka inflaation hidastuminen on vaikuttanut lainojen korkoihin vuonna 2024 ja mitä se tarkoittaa lainanottajille.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/interest-rates-05.jpg"
  },
  {
    id: "asuntomarkkinoiden-ennuste-2025-kannattaako-nyt-ostaa-vai-myyda",
    title: "Asuntomarkkinoiden ennuste 2025: kannattaako nyt ostaa vai myydä?",
    slug: "asuntomarkkinoiden-ennuste-2025-kannattaako-nyt-ostaa-vai-myyda",
    description: "Asiantuntijoiden ennusteet asuntomarkkinoille vuodelle 2025. Ota selvää, onko nyt oikea aika ostaa vai myydä asunto.",
    category: "Asuntolainat",
    date: "2024-06-25",
    readTime: "13 min",
    authorId: "real-estate-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/house-market-06.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/house-market-06.jpg",
    isFeatured: true,
    keywords: ["asuntomarkkinat", "ennuste", "asunto", "ostaminen", "myyminen", "sijoittaminen"],
    summary: "Asiantuntijoiden ennusteet asuntomarkkinoille vuodelle 2025. Ota selvää, onko nyt oikea aika ostaa vai myydä asunto.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/house-market-06.jpg"
  },
  {
    id: "pienyrittajan-rahoitusopas-2025-parhaat-rahoitusvaihtoehdot-eri-tilanteisiin",
    title: "Pienyrittäjän rahoitusopas 2025: parhaat rahoitusvaihtoehdot eri tilanteisiin",
    slug: "pienyrittajan-rahoitusopas-2025-parhaat-rahoitusvaihtoehdot-eri-tilanteisiin",
    description: "Pienyrittäjille suunnattu opas: löydä parhaat rahoitusvaihtoehdot yrityksen eri vaiheisiin ja tarpeisiin vuonna 2024.",
    category: "Yrityslainat",
    date: "2024-07-20",
    readTime: "16 min",
    authorId: "business-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/small-business-07.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/small-business-07.jpg",
    isFeatured: false,
    keywords: ["pienyrittäjä", "rahoitus", "yrityslaina", "investointi", "kasvu", "liiketoiminta"],
    summary: "Pienyrittäjille suunnattu opas: löydä parhaat rahoitusvaihtoehdot yrityksen eri vaiheisiin ja tarpeisiin vuonna 2024.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/small-business-07.jpg"
  },
  {
    id: "vastuullinen-lainaaminen-nain-teet-kestavia-rahoituspaatoksia",
    title: "Vastuullinen lainaaminen: näin teet kestäviä rahoituspäätöksiä",
    slug: "vastuullinen-lainaaminen-nain-teet-kestavia-rahoituspaatoksia",
    description: "Opas vastuulliseen lainaamiseen: miten suunnitella lainanotto, välttää ylivelkaantuminen ja tehdä kestäviä rahoituspäätöksiä.",
    category: "Vastuullisuus",
    date: "2024-08-15",
    readTime: "9 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/responsible-finance-08.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/responsible-finance-08.jpg",
    isFeatured: false,
    keywords: ["vastuullisuus", "laina", "rahoitus", "velka", "talous", "budjetti"],
    summary: "Opas vastuulliseen lainaamiseen: miten suunnitella lainanotto, välttää ylivelkaantuminen ja tehdä kestäviä rahoituspäätöksiä.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/responsible-finance-08.jpg"
  },
  {
    id: "yhdistelylaina-opas",
    title: "Yhdistelylaina opas",
    slug: "yhdistelylaina-opas",
    description: "Yhdistä lainat yhdeksi edullisemmaksi lainaksi. Katso miten yhdistelylaina toimii ja miten voit säästää.",
    category: "Lainaoppaat",
    date: "2024-09-01",
    readTime: "7 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/loans-02.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/loans-02.jpg",
    isFeatured: false,
    keywords: ["yhdistelylaina", "laina", "rahoitus", "velka", "talous"],
    summary: "Yhdistä lainat yhdeksi edullisemmaksi lainaksi. Katso miten yhdistelylaina toimii ja miten voit säästää.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/loans-02.jpg"
  },
  {
    id: "yhdistelylaina-ratkaisu",
    title: "Yhdistelylaina ratkaisu",
    slug: "yhdistelylaina-ratkaisu",
    description: "Yhdistelylaina on ratkaisu useisiin pieniin lainoihin. Katso miten voit maksaa pienet lainat pois yhdellä isommalla.",
    category: "Lainaoppaat",
    date: "2024-09-05",
    readTime: "6 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/credit-card-02.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/credit-card-02.jpg",
    isFeatured: false,
    keywords: ["yhdistelylaina", "laina", "rahoitus", "velka", "talous"],
    summary: "Yhdistelylaina on ratkaisu useisiin pieniin lainoihin. Katso miten voit maksaa pienet lainat pois yhdellä isommalla.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/credit-card-02.jpg"
  },
  {
    id: "koron-nousun-taittuminen",
    title: "Koron nousun taittuminen",
    slug: "koron-nousun-taittuminen",
    description: "Koron nousu on hidastunut. Mitä tämä tarkoittaa lainan ottajalle?",
    category: "Korot",
    date: "2024-09-10",
    readTime: "5 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/money-02.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/money-02.jpg",
    isFeatured: false,
    keywords: ["korot", "laina", "rahoitus", "velka", "talous"],
    summary: "Koron nousu on hidastunut. Mitä tämä tarkoittaa lainan ottajalle?",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/money-02.jpg"
  },
  {
    id: "venelainaopas-nain-rahoitat-unelmiesi-veneen",
    title: "Venelainaopas - Näin rahoitat unelmiesi veneen",
    slug: "venelainaopas-nain-rahoitat-unelmiesi-veneen",
    description: "Veneen hankintaan on tarjolla useita erilaisia rahoitusvaihtoehtoja. Tämä opas auttaa sinua valitsemaan sopivimman ja edullisimman rahoitustavan.",
    category: "Venelainat",
    date: "2025-03-15",
    readTime: "8 min",
    authorId: "finance-expert",
    imageUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/boats/venelaina-hero.jpg",
    thumbnailUrl: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/boats/venelaina-hero.jpg",
    isFeatured: false,
    keywords: ["venelaina", "venerahoitus", "vene", "rahoitus", "osamaksu", "pankkilaina"],
    summary: "Veneen hankintaan on tarjolla useita erilaisia rahoitusvaihtoehtoja. Tämä opas auttaa sinua valitsemaan sopivimman ja edullisimman rahoitustavan.",
    image: "https://zfywjmmtnpdokyxemqsf.supabase.co/storage/v1/object/public/article-images/boats/venelaina-hero.jpg"
  }
];

export const articles = [
  {
    id: "1",
    title: "Korkojen nousu ja vaikutus asuntolainoihin",
    slug: "korkojen-nousu-ja-vaikutus-asuntolainoihin",
    category: "asuntolainat",
    date: "2023-03-15",
    readTime: "5 min",
    description: "Miten korkojen nousu vaikuttaa asuntolainoihin ja mitä voit tehdä?",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["korot", "asuntolaina", "talous"],
    summary: "Miten korkojen nousu vaikuttaa asuntolainoihin ja mitä voit tehdä?",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    isFeatured: false
  },
  {
    id: "2",
    title: "Säästövinkit arkeen",
    slug: "saastovinkit-arkeen",
    category: "lainaoppaat",
    date: "2023-04-01",
    readTime: "7 min",
    description: "Parhaat vinkit arjen säästämiseen ja talouden hallintaan.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["säästäminen", "talous", "budjetointi"],
    summary: "Parhaat vinkit arjen säästämiseen ja talouden hallintaan.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "3",
    title: "Miten valita sopiva kulutusluotto?",
    slug: "miten-valita-sopiva-kulutusluotto",
    category: "kulutusluotot",
    date: "2023-04-15",
    readTime: "6 min",
    description: "Opas oikean kulutusluoton valintaan ja vertailuun.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["kulutusluotto", "laina", "rahoitus"],
    summary: "Opas oikean kulutusluoton valintaan ja vertailuun.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "4",
    title: "Yrityslainan ABC",
    slug: "yrityslainan-abc",
    category: "yrityslainat",
    date: "2023-05-01",
    readTime: "8 min",
    description: "Kaikki mitä sinun tulee tietää yrityslainasta ja sen hakemisesta.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "business-expert",
    keywords: ["yrityslaina", "rahoitus", "yrittäjyys"],
    summary: "Kaikki mitä sinun tulee tietää yrityslainasta ja sen hakemisesta.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "5",
    title: "Sijoittaminen aloittelijoille",
    slug: "sijoittaminen-aloittelijoille",
    category: "lainaoppaat",
    date: "2023-05-15",
    readTime: "9 min",
    description: "Perusopas sijoittamisen maailmaan ja ensimmäisten sijoitusten tekemiseen.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["sijoittaminen", "talous", "osakkeet"],
    summary: "Perusopas sijoittamisen maailmaan ja ensimmäisten sijoitusten tekemiseen.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "6",
    title: "Asuntolainan kilpailutus - miten se onnistuu?",
    slug: "asuntolainan-kilpailutus-miten-se-onnistuu",
    category: "asuntolainat",
    date: "2023-06-01",
    readTime: "7 min",
    description: "Vinkkejä asuntolainan kilpailuttamiseen ja parhaan lainatarjouksen löytämiseen.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["asuntolaina", "kilpailutus", "korot"],
    summary: "Vinkkejä asuntolainan kilpailuttamiseen ja parhaan lainatarjouksen löytämiseen.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "7",
    title: "Pikalainat - hyvät ja huonot puolet",
    slug: "pikalainat-hyvat-ja-huonot-puolet",
    category: "kulutusluotot",
    date: "2023-06-15",
    readTime: "6 min",
    description: "Pikalainojen edut ja haitat sekä vinkkejä vastuulliseen lainaamiseen.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["pikalaina", "laina", "rahoitus"],
    summary: "Pikalainojen edut ja haitat sekä vinkkejä vastuulliseen lainaamiseen.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "8",
    title: "Miten pienentää yrityksen verotusta?",
    slug: "miten-pienentaa-yrityksen-verotusta",
    category: "yrityslainat",
    date: "2023-07-01",
    readTime: "9 min",
    description: "Vinkkejä yrityksen verotuksen optimointiin ja säästöjen maksimointiin.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "business-expert",
    keywords: ["verotus", "yritys", "talous"],
    summary: "Vinkkejä yrityksen verotuksen optimointiin ja säästöjen maksimointiin.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "9",
    title: "Budjetointi - näin aloitat",
    slug: "budjetointi-nain-aloitat",
    category: "lainaoppaat",
    date: "2023-07-15",
    readTime: "7 min",
    description: "Helppo opas budjetoinnin aloittamiseen ja talouden suunnitteluun.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["budjetointi", "talous", "suunnittelu"],
    summary: "Helppo opas budjetoinnin aloittamiseen ja talouden suunnitteluun.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "10",
    title: "Asuntolainan lyhennysvapaa - milloin se kannattaa?",
    slug: "asuntolainan-lyhennysvapaa-milloin-se-kannattaa",
    category: "asuntolainat",
    date: "2023-08-01",
    readTime: "6 min",
    description: "Milloin asuntolainan lyhennysvapaa on hyvä vaihtoehto ja mitä tulee huomioida?",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["asuntolaina", "lyhennysvapaa", "talous"],
    summary: "Milloin asuntolainan lyhennysvapaa on hyvä vaihtoehto ja mitä tulee huomioida?",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "11",
    title: "Luottokortin valinta - mitä ottaa huomioon?",
    slug: "luottokortin-valinta-mita-ottaa-huomioon",
    category: "kulutusluotot",
    date: "2023-08-15",
    readTime: "7 min",
    description: "Opas oikean luottokortin valintaan ja vertailuun eri vaihtoehtojen välillä.",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "finance-expert",
    keywords: ["luottokortti", "laina", "rahoitus"],
    summary: "Opas oikean luottokortin valintaan ja vertailuun eri vaihtoehtojen välillä.",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  },
  {
    id: "12",
    title: "Kannattaako yrityksen investoida?",
    slug: "kannattaako-yrityksen-investoida",
    category: "yrityslainat",
    date: "2023-09-01",
    readTime: "8 min",
    description: "Milloin yrityksen kannattaa investoida ja miten investoinnit suunnitellaan?",
    imageUrl: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    authorId: "business-expert",
    keywords: ["investointi", "yritys", "talous"],
    summary: "Milloin yrityksen kannattaa investoida ja miten investoinnit suunnitellaan?",
    image: "https://images.unsplash.com/photo-1560518883-0adea26c6a2a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
  }
];

export const getCategories = (articles: BaseArticle[]) => {
  const categories = new Set<string>();
  categories.add("Kaikki");
  articles.forEach(article => categories.add(article.category));
  return Array.from(categories);
};

export const validateArticleImages = () => {
  return allArticles.map(article => {
    return {
      ...article,
      imageUrl: article.imageUrl || "https://placehold.co/600x400",
      thumbnailUrl: article.thumbnailUrl || "https://placehold.co/600x400",
      summary: article.summary || article.description,
      image: article.image || article.imageUrl || "https://placehold.co/600x400"
    };
  });
};
